import Header from "@/components/landing/Header";
import Footer from "@/components/landing/Footer";
import IntegrationenHero from "@/components/landing/integrationen/IntegrationenHero";
import IntegrationenGrid from "@/components/landing/integrationen/IntegrationenGrid";
import CTASection from "@/components/landing/CTASection";
import { SEOHead } from "@/hooks/useSEO";
import { useLanguage } from "@/hooks/useLanguage";
import {
  StructuredDataHead,
  LLMMetadataHead,
  organizationSchema,
  createWebPageSchema,
} from "@/hooks/useStructuredData";

const Integrationen = () => {
  const { language } = useLanguage();

  return (
    <div className="min-h-screen bg-background">
      <SEOHead page="integrationen" locale={language} />
      <StructuredDataHead schemas={[
        organizationSchema,
        createWebPageSchema(
          "Integrationen – CRM, WhatsApp, Shopify & mehr | Chathero",
          "Nahtlose Integrationen für HubSpot, WhatsApp, Shopify, TYPO3 und mehr. Verbinden Sie Chathero mit Ihren bestehenden Systemen.",
          "/integrationen",
          [
            { name: "Home", url: "/" },
            { name: "Integrationen", url: "/integrationen" },
          ]
        ),
      ]} />
      <LLMMetadataHead
        title="Integrationen – CRM, WhatsApp, Shopify & mehr | Chathero"
        description="Nahtlose Integrationen für HubSpot, WhatsApp, Shopify, TYPO3 und mehr. Verbinden Sie Chathero mit Ihren bestehenden Systemen für automatisierte Workflows."
        keywords="Chathero Integrationen, HubSpot Integration, WhatsApp Business API, Shopify Chatbot, CRM Integration, Zapier, TYPO3"
        canonicalUrl="https://chathero.ai/integrationen"
        aiCategory="Integrationen, API, Konnektoren"
        aiEntityType="Integrations Page"
        aiFeatures="HubSpot, Pipedrive, Shopify, WooCommerce, TYPO3, Zapier, WhatsApp Business API, Google Meet, Microsoft 365"
      />
      <Header />
      <main>
        <IntegrationenHero />
        <IntegrationenGrid />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Integrationen;
